import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import Style from "./style.module.css";
import Select from "react-select";
import { GlobalContext } from "../../../context/Context";
import { useApiCall } from "../../../component/custom-hooks/api-call";
import LeftSidePopupLayout from "../../../component/popup/modal-layout";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  SelectSearch,
} from "../../../component/form/form-layout";
import XCloseIcon from "../../../component/icons/x-close";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

const AddDealPackage = ({
  onSubmit = () => { },
  onClose = () => { },
  onError = () => { },
  fromPackage = false,
  editData = {},
  packageId,
  packageName
}) => {
  let { state, dispatch } = useContext(GlobalContext);

  const apiCall = useApiCall();

  // useEffect(() => {
  //   if (editData?.id) {
  //     formik.setFieldValue("status_code", editData?.status_code);
  //     formik.setFieldValue("status_name", editData?.status_name);
  //     formik.setFieldValue("category", editData?.category);
  //     formik.setFieldValue("recyclable", editData?.recyclable);
  //     formik.setFieldValue("recycle_days", editData?.recycle_days);
  //     formik.setFieldValue("requires_follow_up", editData?.requires_follow_up);
  //     formik.setFieldValue("description", editData?.description);
  //   }
  // }, [editData]);

  useEffect(() => {
    if (packageName) {
      formik.setFieldValue("category", packageName);
    }
  }, [packageId]);


  const isChanged = () => {
    if (!editData?.id) return true; // new data
    return Object.keys(formik.values).some(
      (key) => formik.values[key] !== editData[key],
    );
  };

  const validationSchema = yup.object({
    customerFullName: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    customerEmailAddress: yup
      .string("This Field is Required")
      .required("This Field is Required")
      .email("Enter a Valid Email"),
    phone: yup
      .string("This Field is Required")
      .required("This Field is Required"),
    category: fromPackage
      ? yup.string().required("This Field is Required")
      : yup.string().notRequired(),
  });

  const formik = useFormik({
    initialValues: {
      customerFullName: "",
      customerEmailAddress: "",
      category: "",
      phone: "",
    },

    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (!isChanged()) {
        console.log("No changes detected. API not called.");
        return;
      }

      let data = {
        customerFullName: values.customerFullName,
        customerEmailAddress: values.customerEmailAddress,
        phone: values.phone,
        pageurl:
          "https://www.squarespacexperts.com/lp/?campaignid=580729625&adgroupid=1267738568835943&keyword=squarespace%20website%20design&device=c&matchtype=p%22&msclkid=f0e821ebf22d14035fc0493798bbbbe7&utm_source=bing&utm_medium=cpc&utm_campaign=SquarespaceXperts%20%7C%20Auto%20-%20Test&utm_term=squarespace%20website%20design&utm_content=Design",
        deal_package: packageId,
        package_name: values.category,
        product: 14
      };

      console.log("packagedata", data)

      try {
        let apiRes;

        apiRes = await apiCall({
          method: "post",
          url: `leads/add-api-lead`,
          data: data,
          customToken: `cda9447a61da03e97a12e923c4c8ac7ef900375176ec3c11679c46a3e7846fd1`
        });

        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error);
        const res = error?.response?.data;

        if (res?.errors) {
          formik.setErrors(
            Object.fromEntries(
              Object.entries(res.errors).map(([key, value]) => [key, value[0]]),
            ),
          );
        }
        onError(
          error?.response.data?.respMsg ||
          error?.response.data?.responseMessage ||
          error?.response.data?.message ||
          "Some Thing Went Wrong",
        );
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout
        popupStatus={true}
        className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}
      >
        <div
          className={`${Style["modal_header"]} ${Style.addMeModal_head} !flex !justify-between !items-center`}
        >
          <h4>{fromPackage ? "Lead With Package" : "Add Lead"}</h4>
          <div
            onClick={onClose}
            className={`${Style["close_btn"]} text-xl flex shrink-0 cursor-pointer hover:text-red-500 p-1 rounded hover:bg-gray-200 transition-all duration-300`}
          >
            <XCloseIcon />
          </div>
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <FormArea>
                  {/* customerFullName */}
                  <FeildWraper width="100%">
                    <FormLabel required>Name</FormLabel>
                    <input
                      name="customerFullName"
                      value={formik.values.customerFullName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter Name"
                    />
                    {formik.touched.customerFullName &&
                      formik.errors.customerFullName && (
                        <FeildError>
                          {formik.errors.customerFullName}
                        </FeildError>
                      )}
                  </FeildWraper>

                  <FeildWraper width="100%">
                    <FormLabel required>Email</FormLabel>
                    <input
                      name="customerEmailAddress"
                      value={formik.values.customerEmailAddress}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="email"
                      placeholder="Enter Email"
                    />
                    {formik.touched.customerEmailAddress &&
                      formik.errors.customerEmailAddress && (
                        <FeildError>
                          {formik.errors.customerEmailAddress}
                        </FeildError>
                      )}
                  </FeildWraper>

                  {/* Phone */}

                  <FeildWraper width="100%">
                    <FormLabel required>Phone</FormLabel>
                    <input
                      name="phone"
                      value={formik.values.phone}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      placeholder="Enter Phone"
                    />
                    {formik.touched.phone && formik.errors.phone && (
                      <FeildError>{formik.errors.phone}</FeildError>
                    )}
                  </FeildWraper>

                  {fromPackage ? (
                    <>
                      <FeildWraper width="100%">
                        <FormLabel required>Package</FormLabel>
                        <input
                          name="category"
                          value={formik.values.category}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          type="text"
                          placeholder="Enter Package"
                          disabled
                        />
                        {formik.touched.category && formik.errors.category && (
                          <FeildError>{formik.errors.category}</FeildError>
                        )}
                      </FeildWraper>
                    </>
                  ) : null}
                </FormArea>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel}`}
            onClick={onClose}
          >
            Discard
          </button>
          <button
            type="submit"
            className={`${Style.dcmb__submit} disabled:!opacity-70 disabled:!cursor-not-allowed`}
            disabled={!isChanged()}
          >
            {editData?.id ? "Update" : "Submit"}
          </button>
        </div>
      </LeftSidePopupLayout>
    </form>
  );
};

export default AddDealPackage;
